import { render } from "./MultilangInput.vue?vue&type=template&id=2f1a305e&ts=true&lang=pug"
import script from "./MultilangInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultilangInput.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__